import Vue from 'vue'
import '@common/components'

import Button from './Button'

import Dropdown from './Dropdown'
import Field from './Field'

import Input from './Input'
import Select from './Select'
import Textarea from './Textarea'
import Checkbox from './Checkbox'
import Radio from './Radio'
import EmojiReaction from './EmojiReaction'

import Card from './Card'

import MediaSpinner from './MediaSpinner'
import LazyMedia from './LazyMedia'

Vue.component('XMediaSpinner', MediaSpinner)

Vue.component('XButton', Button)

Vue.component('XField', Field)

Vue.component('XDropdown', Dropdown)

Vue.component('XInput', Input)
Vue.component('XSelect', Select)
Vue.component('XTextarea', Textarea)
Vue.component('XCheckbox', Checkbox)
Vue.component('XRadio', Radio)
Vue.component('XEmojiReaction', EmojiReaction)

Vue.component('XCard', Card)

Vue.component('XLazyMedia', LazyMedia)
